/*
 *  Copyright 2010-2016 FinTech Neo AS ( fintechneo.com )- All rights reserved
 */

import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './workingdialog.component.html',
    standalone: false
})
export class WorkingDialogComponent {
  data = inject<{
    title: string;
    body: string;
}>(MAT_DIALOG_DATA);
}
